var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "q-tabs",
        {
          staticClass: "shadow-1 bg-white",
          attrs: {
            color: "white",
            "text-color": "primary",
            "underline-color": "primary",
            align: "justify"
          },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "library",
              label: _vm.$t(_vm.title_library),
              icon: "fal fa-books"
            },
            slot: "title"
          }),
          _c(
            "q-tab-pane",
            {
              staticClass: "q-px-md q-pb-xl q-mt-md",
              attrs: { name: "library" }
            },
            [
              _c("div", { staticClass: "row gutter-sm" }, [
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-3" },
                  [
                    _c("filter-library", {
                      on: { changeFilter: _vm.changeFilter }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "col-xs-12 col-sm-9",
                    staticStyle: { "min-height": "700px" }
                  },
                  [
                    _c("div", { staticClass: "row gutter-md" }, [
                      _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _c(
                            "q-infinite-scroll",
                            {
                              ref: "library_scroll",
                              attrs: { handler: _vm.loadLibraries, offset: 10 }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "row gutter-md" },
                                _vm._l(_vm.libraries, function(library, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: index,
                                      staticClass: "col-xs-12 col-sm-4"
                                    },
                                    [
                                      _c("card-library", {
                                        key: library.id,
                                        attrs: { library: library },
                                        on: {
                                          cardClicked: _vm.showModal,
                                          changeHits: _vm.changeHits
                                        }
                                      })
                                    ],
                                    1
                                  )
                                }),
                                0
                              ),
                              _c(
                                "div",
                                { staticClass: "text-center q-mt-xl" },
                                [
                                  _vm.has_next_page
                                    ? _c("q-spinner-dots", {
                                        attrs: { slot: "message", size: 40 },
                                        slot: "message"
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  ]
                )
              ]),
              _c("modal-library", {
                attrs: { library: _vm.library, show: _vm.show_modal },
                on: { hideModal: _vm.hideModal, changeHits: _vm.changeHits }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }